import React from "react";

const projectsIcon = (
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="sidenav-svg"
  >
    <path d="M27.8638 13.0217L23.3672 10.7735L27.8638 8.52509C28.6681 8.12305 28.6689 6.97119 27.8638 6.56851L14.9575 0.115357C14.6494 -0.0384523 14.2871 -0.0384523 13.9791 0.115357L1.07278 6.56851C0.268485 6.97077 0.267631 8.12263 1.07278 8.52509L5.56935 10.7735L1.07278 13.0217C0.268485 13.4239 0.267631 14.5756 1.07278 14.9782L5.56935 17.2266L1.07278 19.4748C0.268485 19.8771 0.267631 21.0287 1.07278 21.4314L13.9791 27.8846C14.2865 28.0382 14.6488 28.0388 14.9575 27.8846L27.8638 21.4314C28.6681 21.0291 28.6689 19.8775 27.8638 19.4748L23.3672 17.2266L27.8638 14.9782C28.6681 14.5762 28.6689 13.4243 27.8638 13.0217ZM14.4683 2.31654L24.9288 7.54691L14.4683 12.7771L4.00776 7.54691L14.4683 2.31654ZM24.9288 20.4532L14.4683 25.6834L4.00776 20.4532L8.01513 18.4494L13.9791 21.4314C14.2867 21.585 14.6488 21.5856 14.9575 21.4314L20.9214 18.4494L24.9288 20.4532ZM14.4683 19.2302L4.00776 14.0001L8.01513 11.9963L13.9791 14.9782C14.2867 15.1318 14.6488 15.1325 14.9575 14.9782L20.9214 11.9963L24.9288 14.0001L14.4683 19.2302Z" />
  </svg>
);
const logoIcon = (
  <svg
    width="38"
    height="70"
    viewBox="0 0 38 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.5999 60.9844C36.6454 57.8045 37.5761 54.3511 37.3917 50.6238L37.3243 34.9109L37.3916 19.2335C37.5759 15.5063 36.6453 12.0528 34.5998 8.87292C31.9565 4.75906 28.2165 2.11261 23.3795 0.933649C18.5427 -0.245464 13.9721 0.386922 9.66785 2.83083C5.36381 5.27472 2.52971 8.84863 1.16609 13.5529C-0.197528 18.2569 0.294424 22.767 2.64258 27.0832C4.55301 30.5948 7.26138 33.1642 10.7677 34.7917C11.0842 33.2716 11.8297 31.9299 13.0049 30.7666C14.5911 29.1963 16.5003 28.3884 18.7331 28.343C20.9658 28.2977 22.9122 29.0236 24.5726 30.5207C25.897 31.7154 26.8514 33.0697 27.156 34.7172L27.1362 43.4528C27.1304 43.7661 27.1479 44.0671 27.1883 44.3557L27.1931 51.9683C27.0913 54.0916 26.2346 55.8801 24.6233 57.3334C22.9629 58.8302 21.0166 59.5564 18.7838 59.5111C16.5511 59.4654 14.6419 58.6578 13.0557 57.0874C11.6061 55.6524 10.7579 53.9462 10.6148 51.9683L10.5817 44.2234C10.5921 42.3271 9.73993 40.8834 8.02532 39.8925C6.31052 38.9016 4.6074 38.9092 2.91561 39.9155C1.22396 40.9216 0.395668 42.3844 0.430419 44.3035L0.447784 51.9683C0.512762 53.395 0.741816 54.8404 1.16624 56.3042C2.52985 61.0084 5.36395 64.5824 9.66798 67.0261C13.9722 69.4703 18.5428 70.1025 23.3797 68.9235C28.2167 67.7445 31.9567 65.0983 34.5999 60.9844ZM27.2002 18.0829C27.1424 15.8742 26.2834 14.0213 24.6232 12.5239C22.9628 11.0268 21.0164 10.3009 18.7837 10.3462C16.551 10.3916 14.6417 11.1995 13.0555 12.7698C11.4692 14.3401 10.6652 16.2355 10.6435 18.4557C10.6216 20.6759 11.4011 22.5684 12.982 24.1331C14.5627 25.6977 16.4698 26.513 18.7032 26.5791C20.9363 26.6454 22.8806 25.9322 24.5356 24.4395C26.1906 22.9469 27.0803 21.107 27.2049 18.9196L27.2002 18.0829Z"
      fill="#FFE300"
    />
  </svg>
);
const registerIcon = (
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    className="sidenav-svg"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path d="M27.3208 12.9062H20.1021V1.09375C20.1021 0.489672 19.6124 0 19.0083 0H1.5083C0.904223 0 0.414551 0.489672 0.414551 1.09375V22.5312C0.414551 25.5467 2.86778 28 5.8833 28H22.9458C26.0009 28 28.4146 25.5279 28.4146 22.5312V14C28.4146 13.3959 27.9249 12.9062 27.3208 12.9062ZM5.8833 25.8125C4.07402 25.8125 2.60205 24.3405 2.60205 22.5312V2.1875H17.9146C17.9146 2.26751 17.9146 21.9795 17.9146 22.5312C17.9146 23.7159 18.2915 24.8583 19.005 25.8125H5.8833ZM26.2271 22.5312C26.2271 24.2632 24.889 25.6898 23.17 25.8048C21.4349 25.6943 20.1021 24.2534 20.1021 22.5312V15.0938H26.2271V22.5312Z" />
      <path d="M10.2583 4.70312C8.14747 4.70312 6.43018 6.66575 6.43018 9.07812C6.43018 11.4905 8.14747 13.4531 10.2583 13.4531C12.3691 13.4531 14.0864 11.4905 14.0864 9.07812C14.0864 6.66575 12.3691 4.70312 10.2583 4.70312ZM10.2583 11.2656C9.36897 11.2656 8.61768 10.2639 8.61768 9.07812C8.61768 7.89239 9.36897 6.89062 10.2583 6.89062C11.1476 6.89062 11.8989 7.89239 11.8989 9.07812C11.8989 10.2639 11.1476 11.2656 10.2583 11.2656Z" />
      <path d="M14.6333 21.4375H5.8833C5.27922 21.4375 4.78955 21.9272 4.78955 22.5312C4.78955 23.1353 5.27922 23.625 5.8833 23.625H14.6333C15.2374 23.625 15.7271 23.1353 15.7271 22.5312C15.7271 21.9272 15.2374 21.4375 14.6333 21.4375Z" />
      <path d="M14.6333 17.0625H5.8833C5.27922 17.0625 4.78955 17.5522 4.78955 18.1562C4.78955 18.7603 5.27922 19.25 5.8833 19.25H14.6333C15.2374 19.25 15.7271 18.7603 15.7271 18.1562C15.7271 17.5522 15.2374 17.0625 14.6333 17.0625Z" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="28"
          height="28"
          fill="white"
          transform="translate(0.414551)"
        />
      </clipPath>
    </defs>
  </svg>
);
const usersIcon = (
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="sidenav-svg"
  >
    <path d="M18.5708 0C16.9955 0 15.5197 0.605117 14.4146 1.66474C13.3094 0.605117 11.8336 0 10.2583 0C6.94129 0 4.24268 2.69861 4.24268 6.01562C4.24268 9.33264 6.94129 12.0312 10.2583 12.0312C11.8337 12.0312 13.3096 11.4261 14.4146 10.3666C15.5198 11.4262 16.9956 12.0312 18.5708 12.0312C21.8878 12.0312 24.5864 9.33264 24.5864 6.01562C24.5864 2.69861 21.8878 0 18.5708 0ZM14.084 6.15218C14.0122 8.18962 12.3451 9.84375 10.2583 9.84375C8.14747 9.84375 6.43018 8.12645 6.43018 6.01562C6.43018 3.9048 8.14747 2.1875 10.2583 2.1875C12.4432 2.1875 14.16 3.99848 14.084 6.15218ZM18.5708 9.84375C17.4622 9.84375 16.4307 9.37322 15.7102 8.56062C16.065 7.80161 16.2454 6.99634 16.2705 6.21004C16.3013 5.24759 16.1011 4.30686 15.7102 3.47063C16.4307 2.65803 17.4622 2.1875 18.5708 2.1875C20.6816 2.1875 22.3989 3.9048 22.3989 6.01562C22.3989 8.12645 20.6816 9.84375 18.5708 9.84375Z" />
    <path d="M25.8732 16.1482C24.009 14.0879 21.3473 12.9062 18.5708 12.9062C17.1339 12.9062 15.7088 13.2228 14.4146 13.8252C13.1203 13.2228 11.6952 12.9062 10.2583 12.9062C7.48176 12.9062 4.82012 14.0879 2.95561 16.1485C1.31695 17.9608 0.414551 20.3053 0.414551 22.75V26.9062C0.414551 27.5103 0.904223 28 1.5083 28C1.93645 28 26.9468 28 27.3208 28C27.9249 28 28.4146 27.5103 28.4146 26.9062V22.75C28.4146 20.3053 27.5122 17.9608 25.8732 16.1482ZM17.9146 25.8125H2.60205V22.75C2.60205 20.8484 3.30386 19.025 4.57791 17.6159C6.02822 16.013 8.09869 15.0938 10.2583 15.0938C14.4873 15.0938 17.9146 18.5212 17.9146 22.75V25.8125ZM26.2271 25.8125H20.1021V22.75C20.1021 19.896 18.8716 17.1953 16.7175 15.3209C17.3214 15.1708 17.9445 15.0938 18.5708 15.0938C20.7304 15.0938 22.8009 16.013 24.2509 17.6156C25.5252 19.025 26.2271 20.8484 26.2271 22.75V25.8125Z" />
  </svg>
);
const profileIcon = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2507 16.8597C19.5669 16.8597 21.5723 16.029 23.2113 14.3899C24.8498 12.7512 25.6808 10.7461 25.6808 8.42961C25.6808 6.11394 24.85 4.10856 23.211 2.46927C21.572 0.830786 19.5666 6.10352e-05 17.2507 6.10352e-05C14.9342 6.10352e-05 12.9291 0.830786 11.2903 2.46954C9.65155 4.10829 8.82056 6.11367 8.82056 8.42961C8.82056 10.7461 9.65155 12.7515 11.2903 14.3902C12.9296 16.0287 14.935 16.8597 17.2507 16.8597ZM12.7408 3.91977C13.9982 2.66233 15.4733 2.05111 17.2507 2.05111C19.0277 2.05111 20.5031 2.66233 21.7608 3.91977C23.0182 5.17747 23.6297 6.6528 23.6297 8.42961C23.6297 10.207 23.0182 11.682 21.7608 12.9397C20.5031 14.1974 19.0277 14.8086 17.2507 14.8086C15.4738 14.8086 13.9988 14.1972 12.7408 12.9397C11.4831 11.6823 10.8716 10.207 10.8716 8.42961C10.8716 6.6528 11.4831 5.17747 12.7408 3.91977Z"
      fill="#FFE300"
    />
    <path
      d="M32.001 26.9133C31.9537 26.2313 31.8581 25.4873 31.7174 24.7017C31.5754 23.9103 31.3924 23.162 31.1735 22.4782C30.947 21.7714 30.6397 21.0733 30.2592 20.4044C29.8648 19.7102 29.4012 19.1056 28.881 18.6081C28.3371 18.0877 27.6711 17.6693 26.901 17.3641C26.1336 17.0604 25.2831 16.9066 24.3733 16.9066C24.016 16.9066 23.6705 17.0532 23.0032 17.4877C22.5925 17.7555 22.1121 18.0653 21.5759 18.4079C21.1174 18.7 20.4963 18.9737 19.7292 19.2215C18.9807 19.4637 18.2207 19.5865 17.4704 19.5865C16.7205 19.5865 15.9606 19.4637 15.2116 19.2215C14.4452 18.974 13.8238 18.7003 13.3661 18.4081C12.835 18.0687 12.3544 17.759 11.9375 17.4874C11.2708 17.053 10.9252 16.9064 10.5679 16.9064C9.6579 16.9064 8.80768 17.0604 8.0405 17.3643C7.27093 17.669 6.60469 18.0874 6.06022 18.6084C5.54005 19.1062 5.07648 19.7104 4.68235 20.4044C4.30237 21.0733 3.99475 21.7711 3.76831 22.4785C3.54961 23.1623 3.3667 23.9103 3.22464 24.7017C3.08365 25.4863 2.98832 26.2305 2.94106 26.9141C2.89459 27.5824 2.87109 28.278 2.87109 28.9809C2.87109 30.8079 3.45188 32.2869 4.59717 33.3777C5.7283 34.4541 7.22473 34.9999 9.04507 34.9999H25.8978C27.7176 34.9999 29.214 34.4541 30.3454 33.3777C31.491 32.2877 32.0718 30.8081 32.0718 28.9806C32.0715 28.2754 32.0477 27.5798 32.001 26.9133ZM28.9312 31.8917C28.1838 32.6031 27.1915 32.9489 25.8975 32.9489H9.04507C7.75078 32.9489 6.7585 32.6031 6.01135 31.892C5.27836 31.1943 4.92214 30.2418 4.92214 28.9809C4.92214 28.325 4.94377 27.6775 4.98703 27.0559C5.02922 26.446 5.11547 25.776 5.24338 25.0641C5.36968 24.361 5.53043 23.7012 5.72163 23.1038C5.90508 22.5311 6.15528 21.9639 6.46557 21.4175C6.7617 20.8968 7.10243 20.4501 7.47841 20.0902C7.83009 19.7534 8.27335 19.4779 8.79566 19.2712C9.27872 19.08 9.82159 18.9753 10.4109 18.9596C10.4827 18.9977 10.6107 19.0706 10.8179 19.2058C11.2395 19.4805 11.7255 19.794 12.2628 20.1371C12.8684 20.5233 13.6486 20.872 14.5808 21.173C15.5339 21.4811 16.5059 21.6376 17.4706 21.6376C18.4354 21.6376 19.4077 21.4811 20.3601 21.1732C21.2931 20.8717 22.0731 20.5233 22.6796 20.1366C23.2294 19.7852 23.7017 19.4808 24.1234 19.2058C24.3306 19.0709 24.4585 18.9977 24.5303 18.9596C25.1199 18.9753 25.6628 19.08 26.1461 19.2712C26.6682 19.4779 27.1114 19.7537 27.4631 20.0902C27.8391 20.4498 28.1798 20.8966 28.476 21.4178C28.7865 21.9639 29.037 22.5313 29.2202 23.1036C29.4116 23.7017 29.5726 24.3613 29.6987 25.0638C29.8263 25.7771 29.9128 26.4473 29.955 27.0561V27.0567C29.9986 27.6759 30.0204 28.3232 30.0207 28.9809C30.0204 30.242 29.6642 31.1943 28.9312 31.8917Z"
      fill="#FFE300"
    />
  </svg>
);
const reportIcon = (
  <svg
    width="25"
    height="31"
    viewBox="0 0 25 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.9227 6.42281L18.3273 1.82731C17.7179 1.21794 16.8907 0.875061 16.0295 0.875061H4.375C2.57937 0.875061 1.125 2.32944 1.125 4.12506V26.8751C1.125 28.6707 2.57937 30.1251 4.375 30.1251H20.625C22.4206 30.1251 23.875 28.6707 23.875 26.8751V8.72056C23.875 7.85931 23.5321 7.03219 22.9227 6.42281V6.42281Z"
      stroke="#FFE300"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.875 9.00006H17.375C16.478 9.00006 15.75 8.27206 15.75 7.37506V0.875061"
      stroke="#FFE300"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 18.7501H15.75"
      stroke="#FFE300"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 23.6251H13.0363"
      stroke="#FFE300"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const reportIconWhite = (
  <svg
    width="25"
    height="31"
    viewBox="0 0 25 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.9227 6.42281L18.3273 1.82731C17.7179 1.21794 16.8907 0.875061 16.0295 0.875061H4.375C2.57937 0.875061 1.125 2.32944 1.125 4.12506V26.8751C1.125 28.6707 2.57937 30.1251 4.375 30.1251H20.625C22.4206 30.1251 23.875 28.6707 23.875 26.8751V8.72056C23.875 7.85931 23.5321 7.03219 22.9227 6.42281V6.42281Z"
      stroke="#FFF"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.875 9.00006H17.375C16.478 9.00006 15.75 8.27206 15.75 7.37506V0.875061"
      stroke="#FFF"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 18.7501H15.75"
      stroke="#FFF"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 23.6251H13.0363"
      stroke="#FFF"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const arrowLeftIcon = (
  <svg
    width="21"
    height="19"
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.7378 7.53088C19.6519 7.51694 19.5649 7.51051 19.4779 7.51163H4.66281L4.98586 7.36138C5.30163 7.21192 5.58889 7.00852 5.83479 6.76036L9.98931 2.60584C10.5365 2.08352 10.6284 1.24327 10.2072 0.614979C9.71693 -0.0545431 8.77676 -0.199914 8.10719 0.290337C8.0531 0.329966 8.00169 0.373164 7.95337 0.419649L0.440678 7.93234C-0.146439 8.5188 -0.146955 9.47014 0.439505 10.0573C0.43988 10.0576 0.440303 10.0581 0.440678 10.0584L7.95337 17.5711C8.54096 18.1571 9.4923 18.1558 10.0783 17.5682C10.1244 17.5219 10.1675 17.4727 10.2072 17.4209C10.6284 16.7926 10.5365 15.9523 9.98931 15.43L5.84231 11.268C5.62185 11.0473 5.3684 10.8622 5.09104 10.7196L4.64027 10.5167H19.3952C20.1628 10.5452 20.8362 10.009 20.9804 9.25458C21.1132 8.43546 20.5569 7.66376 19.7378 7.53088Z"
      fill="black"
    />
  </svg>
);
const searchIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.361 18.2168L14.601 13.2662C15.8249 11.8113 16.4954 9.98069 16.4954 8.07499C16.4954 3.62251 12.8729 0 8.42045 0C3.96797 0 0.345459 3.62251 0.345459 8.07499C0.345459 12.5275 3.96797 16.15 8.42045 16.15C10.092 16.15 11.6849 15.6458 13.0467 14.6888L17.8429 19.677C18.0434 19.8852 18.313 20 18.602 20C18.8755 20 19.1349 19.8957 19.3319 19.7061C19.7504 19.3034 19.7637 18.6357 19.361 18.2168ZM8.42045 2.10652C11.7115 2.10652 14.3889 4.78391 14.3889 8.07499C14.3889 11.3661 11.7115 14.0435 8.42045 14.0435C5.12936 14.0435 2.45198 11.3661 2.45198 8.07499C2.45198 4.78391 5.12936 2.10652 8.42045 2.10652Z"
      fill="#4F4F4F"
    />
  </svg>
);
const notificationIcon = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1C16.4187 1 20 4.58133 20 9"
      stroke="gray"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 9V14.3333"
      stroke="gray"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 1C7.58133 1 4 4.58133 4 9"
      stroke="gray"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 9V14.3333"
      stroke="gray"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 14.3333C20 15.648 20.596 16.892 21.6213 17.716"
      stroke="gray"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 14.3333C4 15.648 3.404 16.892 2.37866 17.716"
      stroke="gray"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.37869 17.716L1.96669 18.0467C0.745357 19.028 1.44002 21 3.00669 21H20.9934C22.56 21 23.2547 19.028 22.0334 18.0467L21.6214 17.716"
      stroke="gray"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 25H14"
      stroke="gray"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const configIcon = (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M2 4.49072H4.04667"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.88277 3.27439C7.53365 3.94624 7.53365 5.03552 6.88277 5.70737C6.2319 6.37922 5.17663 6.37922 4.52575 5.70737C3.87488 5.03552 3.87488 3.94624 4.52575 3.27439C5.17663 2.60255 6.2319 2.60255 6.88277 3.27439"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.37354 4.49072H14.0002"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.88277 3.27439C7.53365 3.94624 7.53365 5.03552 6.88277 5.70737C6.2319 6.37922 5.17663 6.37922 4.52575 5.70737C3.87488 5.03552 3.87488 3.94624 4.52575 3.27439C5.17663 2.60255 6.2319 2.60255 6.88277 3.27439"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 8.96387H11.96"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.62667 8.96387H2"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4746 7.74754C12.1254 8.41939 12.1254 9.50867 11.4746 10.1805C10.8237 10.8524 9.76842 10.8524 9.11755 10.1805C8.46668 9.50867 8.46668 8.41939 9.11755 7.74754C9.76842 7.07569 10.8237 7.07569 11.4746 7.74754Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.37354 13.437H14.0002"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 13.437H4.04"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.88277 12.2202C7.53365 12.892 7.53365 13.9813 6.88277 14.6532C6.2319 15.325 5.17663 15.325 4.52575 14.6532C3.87488 13.9813 3.87488 12.892 4.52575 12.2202C5.17663 11.5483 6.2319 11.5483 6.88277 12.2202Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="16"
          height="16.5156"
          fill="white"
          transform="translate(0 0.706055)"
        />
      </clipPath>
    </defs>
  </svg>
);
const ellipsisIcon = (
  <svg
    width="16"
    height="4"
    viewBox="0 0 16 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="2" cy="2" r="2" fill="#4F4F4F" />
    <circle cx="8" cy="2" r="2" fill="#4F4F4F" />
    <circle cx="14" cy="2" r="2" fill="#4F4F4F" />
  </svg>
);
const eyeIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0419731 8.77494C0.0480461 8.75931 0.0546989 8.74392 0.0619354 8.72878C0.860147 7.07097 2.10242 5.66867 3.65427 4.67342C5.24878 3.65081 7.0973 3.11035 8.99989 3.11035C10.9025 3.11035 12.7511 3.65089 14.3456 4.67359C15.8918 5.66518 17.1306 7.06099 17.9291 8.71082C18.0186 8.88224 18.0253 9.0895 17.9383 9.27024C17.1401 10.9283 15.8979 12.3308 14.3458 13.3263C12.7512 14.349 10.9026 14.8896 8.99989 14.8896C7.09722 14.8896 5.24861 14.349 3.6541 13.3263C2.10209 12.331 0.859898 10.9285 0.0616856 9.27065C-0.0130043 9.11537 -0.0199909 8.93563 0.0419731 8.77494ZM8.99989 13.6419C12.209 13.6419 15.1896 11.8296 16.6778 8.99984C15.1896 6.17004 12.209 4.35787 8.99989 4.35787C5.7909 4.35787 2.81014 6.17021 1.32201 8.99993C2.81023 11.8295 5.79099 13.6419 8.99989 13.6419Z"
      fill="#4F4F4F"
    />
    <path
      d="M8.99998 6.26221C10.5096 6.26221 11.7378 7.49042 11.7378 9.00002C11.7378 10.5096 10.5096 11.7378 8.99998 11.7378C7.49039 11.7378 6.26218 10.5096 6.26218 9.00002C6.26218 7.49042 7.49039 6.26221 8.99998 6.26221ZM8.99998 10.4902C9.82165 10.4902 10.4902 9.82168 10.4902 9.00002C10.4902 8.17835 9.82165 7.5098 8.99998 7.5098C8.17832 7.5098 7.50977 8.17835 7.50977 9.00002C7.50977 9.82168 8.17832 10.4902 8.99998 10.4902Z"
      fill="#4F4F4F"
    />
  </svg>
);
const checkedIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6.25L6.25 8.5"
      stroke="#4F4F4F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.75L6.25 8.5"
      stroke="#4F4F4F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5 13H2.5C1.67125 13 1 12.3288 1 11.5V2.5C1 1.67125 1.67125 1 2.5 1H11.5C12.3288 1 13 1.67125 13 2.5V11.5C13 12.3288 12.3288 13 11.5 13Z"
      stroke="#4F4F4F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const commentIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.6665 11.8889V15"
      stroke="#4F4F4F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.6665 15.0164L9.55539 11.8889"
      stroke="#4F4F4F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.66667 11.8889C3.08911 11.8889 1 9.79978 1 7.22222V5.66667C1 3.08911 3.08911 1 5.66667 1H10.3333C12.9109 1 15 3.08911 15 5.66667V7.22222C15 9.79978 12.9109 11.8889 10.3333 11.8889H9.55556"
      stroke="#4F4F4F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const clipsIcon = (
  <svg
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1871 5.73457L6.52911 10.3926C5.85239 11.0693 4.75479 11.0693 4.07737 10.3926C3.40064 9.71588 3.40064 8.61828 4.07737 7.94086L7.26408 4.75415"
      stroke="#4F4F4F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.11768 6.95777L7.26245 1.81299"
      stroke="#4F4F4F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.51001 12.3535C6.02066 13.8428 3.60636 13.8428 2.11701 12.3535C0.627662 10.8641 0.627662 8.4498 2.11701 6.96045"
      stroke="#4F4F4F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.26514 1.81228C8.34817 0.72924 10.1045 0.72924 11.1875 1.81228C12.2705 2.89532 12.2705 4.65161 11.1875 5.73465"
      stroke="#4F4F4F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.51221 12.3521L11.187 8.67725"
      stroke="#4F4F4F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const clockIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M5.95915 3.74054C8.68019 2.61348 11.7997 3.90565 12.9268 6.62669C14.0538 9.34773 12.7617 12.4672 10.0406 13.5943C7.31959 14.7214 4.20008 13.4292 3.07301 10.7082C1.94594 7.98713 3.23811 4.86762 5.95915 3.74054"
        stroke="#4F4F4F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.29932 3.87336L4.29932 2.19336"
        stroke="#4F4F4F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7065 3.87995L11.7065 2.19995"
        stroke="#4F4F4F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9995 12.5532L13.3328 13.8866"
        stroke="#4F4F4F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.6665 13.8866L3.99984 12.5532"
        stroke="#4F4F4F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99967 10.3666L7.83301 9.04663"
        stroke="#4F4F4F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.83301 6.28662V9.04662"
        stroke="#4F4F4F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const pauseIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6296 23H17.3704C16.0607 23 15 21.9061 15 20.5556V3.44444C15 2.09389 16.0607 1 17.3704 1H20.6296C21.9393 1 23 2.09389 23 3.44444V20.5556C23 21.9061 21.9393 23 20.6296 23Z"
      fill="white"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.62963 23H3.37037C2.06074 23 1 21.9061 1 20.5556V3.44444C1 2.09389 2.06074 1 3.37037 1H6.62963C7.93926 1 9 2.09389 9 3.44444V20.5556C9 21.9061 7.93926 23 6.62963 23Z"
      fill="white"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const imageIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M17.4977 18.375H3.50293C2.53605 18.375 1.75293 17.5919 1.75293 16.625V4.375C1.75293 3.40812 2.53605 2.625 3.50293 2.625H17.4977C18.4646 2.625 19.2477 3.40812 19.2477 4.375V16.625C19.2477 17.5919 18.4637 18.375 17.4977 18.375Z"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.23744 6.63756C8.92086 7.32098 8.92086 8.42902 8.23744 9.11244C7.55402 9.79586 6.44598 9.79586 5.76256 9.11244C5.07915 8.42902 5.07915 7.32098 5.76256 6.63756C6.44598 5.95415 7.55402 5.95415 8.23744 6.63756"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 14.0001L15.5584 11.047C15.1813 10.7451 14.63 10.8064 14.3281 11.1835L11.4091 14.8322C11.1073 15.2094 10.5569 15.2706 10.1789 14.9687L8.54438 13.6606C8.1725 13.3631 7.63088 13.4174 7.3255 13.784L3.5 18.3751"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="21" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const messageMediumIcon = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M11.25 26.2499L17.5 21.2236"
        stroke="#4F4F4F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 21.25V26.25"
        stroke="#4F4F4F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 21.25C7.1075 21.25 3.75 17.8925 3.75 13.75V11.25C3.75 7.1075 7.1075 3.75 11.25 3.75H18.75C22.8925 3.75 26.25 7.1075 26.25 11.25V13.75C26.25 17.8925 22.8925 21.25 18.75 21.25H17.5"
        stroke="#4F4F4F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const micIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <line
        x1="9.5"
        y1="9.5"
        x2="13.5"
        y2="9.5"
        stroke="#4F4F4F"
        strokeLinecap="round"
      />
      <line
        x1="9.5"
        y1="11.5"
        x2="13.5"
        y2="11.5"
        stroke="#4F4F4F"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4997 15.75C11.9139 15.75 12.2497 16.0858 12.2497 16.5L12.2497 20.5H13.6596C14.0738 20.5 14.4096 20.8358 14.4096 21.25C14.4096 21.6642 14.0738 22 13.6596 22H9.33984C8.92563 22 8.58984 21.6642 8.58984 21.25C8.58984 20.8358 8.92563 20.5 9.33984 20.5H10.7497L10.7497 16.5C10.7497 16.0858 11.0855 15.75 11.4997 15.75Z"
        fill="#4F4F4F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 11.5V7.5C15.5 5.29086 13.7091 3.5 11.5 3.5C9.29086 3.5 7.5 5.29086 7.5 7.5V11.5C7.5 13.7091 9.29086 15.5 11.5 15.5C13.7091 15.5 15.5 13.7091 15.5 11.5ZM11.5 2C8.46243 2 6 4.46243 6 7.5V11.5C6 14.5376 8.46243 17 11.5 17C14.5376 17 17 14.5376 17 11.5V7.5C17 4.46243 14.5376 2 11.5 2Z"
        fill="#4F4F4F"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const filesIcon = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M20.3234 10.6556L13.0455 17.9334C11.9882 18.9908 10.2733 18.9908 9.21487 17.9334C8.15754 16.8761 8.15754 15.1612 9.21487 14.1028L14.1939 9.12378"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.15332 12.5667L14.1917 4.52832"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5786 20.997C12.2516 23.324 8.47948 23.324 6.15248 20.997C3.82548 18.67 3.82548 14.8978 6.15248 12.5708"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1963 4.52718C15.8885 2.83501 18.6325 2.83501 20.3247 4.52718C22.0169 6.21935 22.0169 8.96343 20.3247 10.6556"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.582 20.9951L20.3237 15.2534"
        stroke="#4F4F4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="26" height="26" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const myProjectDetail = (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="0.5" y1="-2.18557e-08" x2="0.500001" y2="14" stroke="black" />
    <rect x="3.5" y="0.5" width="16" height="5" stroke="black" />
    <rect x="3.5" y="8.5" width="16" height="5" stroke="black" />
  </svg>
);

const starIcon = (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4992 18.209L16.5386 20.844C17.5198 21.3565 18.6657 20.5278 18.4785 19.4415L17.5161 13.859L21.5943 9.9078C22.3883 9.1378 21.9511 7.79656 20.853 7.63781L15.2194 6.82281L12.7003 1.74156C12.2103 0.752813 10.7919 0.752813 10.3019 1.74156L7.78157 6.82281L2.14668 7.63781C1.04985 7.79656 0.611372 9.1378 1.40541 9.9078L5.48364 13.859L4.52125 19.4415C4.33405 20.5278 5.47987 21.3578 6.46111 20.844L11.5005 18.209"
      fill="white"
    />
    <path
      d="M11.4992 18.209L16.5386 20.844C17.5198 21.3565 18.6657 20.5278 18.4785 19.4415L17.5161 13.859L21.5943 9.9078C22.3883 9.1378 21.9511 7.79656 20.853 7.63781L15.2194 6.82281L12.7003 1.74156C12.2103 0.752813 10.7919 0.752813 10.3019 1.74156L7.78157 6.82281L2.14668 7.63781C1.04985 7.79656 0.611372 9.1378 1.40541 9.9078L5.48364 13.859L4.52125 19.4415C4.33405 20.5278 5.47987 21.3578 6.46111 20.844L11.5005 18.209"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const reflectIcon = (
  <svg
    width="135"
    height="177"
    viewBox="0 0 135 177"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.3" filter="url(#filter0_d_4446_26014)">
      <path
        d="M114.352 -4.31718C113.291 16.7357 101.958 48.5098 58.9771 47.4623C23.3362 46.5938 3.70774 97.1037 0.352577 132.966L0.352653 152.683C-0.339172 147.116 -0.338442 140.352 0.352577 132.966L0.352052 -4.3172L114.352 -4.31718Z"
        fill="#FAFAFA"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4446_26014"
        x="-20.1659"
        y="-20.3174"
        width="154.518"
        height="197"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4446_26014"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4446_26014"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export {
  projectsIcon,
  logoIcon,
  registerIcon,
  usersIcon,
  profileIcon,
  reportIcon,
  reportIconWhite,
  arrowLeftIcon,
  searchIcon,
  notificationIcon,
  configIcon,
  ellipsisIcon,
  eyeIcon,
  checkedIcon,
  commentIcon,
  clipsIcon,
  clockIcon,
  pauseIcon,
  imageIcon,
  messageMediumIcon,
  micIcon,
  filesIcon,
  myProjectDetail,
  starIcon,
  reflectIcon,
};
